import { render, staticRenderFns } from "./SupplyPointCreate.vue?vue&type=template&id=3ecaf36c"
import script from "./SupplyPointCreate.vue?vue&type=script&lang=js"
export * from "./SupplyPointCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports